var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6053 9.02508H18.5C18.5 4.16525 14.8308 0.5 9.96411 0.5V2.39467C13.8124 2.39467 16.6053 5.18268 16.6053 9.02508Z",
    fill: "black",
    fillOpacity: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.97408 6.18516C11.9664 6.18516 12.8162 7.03492 12.8162 9.02717H14.711C14.711 5.97201 13.0294 4.29048 9.97408 4.29048V6.18516ZM13.216 11.3415C13.034 11.1761 12.7948 11.0878 12.5489 11.0954C12.303 11.103 12.0697 11.2059 11.8982 11.3822L9.63112 13.7136C9.08543 13.6094 7.98837 13.2674 6.85909 12.1411C5.72981 11.0109 5.3878 9.91103 5.28644 9.36916L7.61604 7.10123C7.79265 6.92989 7.89565 6.69655 7.90325 6.45061C7.91086 6.20467 7.82246 5.96541 7.65678 5.78349L4.15621 1.93446C3.99046 1.75196 3.76009 1.64126 3.51403 1.62587C3.26797 1.61048 3.0256 1.69162 2.8384 1.85204L0.782587 3.61503C0.618795 3.77941 0.521033 3.99818 0.507846 4.22985C0.493635 4.46669 0.222685 10.0768 4.57306 14.4289C8.36826 18.223 13.1222 18.5005 14.4315 18.5005C14.6229 18.5005 14.7403 18.4949 14.7716 18.493C15.0033 18.48 15.2219 18.3818 15.3855 18.2173L17.1476 16.1606C17.3082 15.9735 17.3895 15.7313 17.3743 15.4852C17.3591 15.2392 17.2485 15.0087 17.0662 14.8429L13.216 11.3415V11.3415Z",
    fill: "black",
    fillOpacity: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPhone);
export default __webpack_public_path__ + "static/media/icon_phone.43cdee3146169318be29fd9e5ff303f6.svg";
export { ForwardRef as ReactComponent };